import { Banner } from 'components/Banner';
import { ExternalLink } from 'components/Link';
import Row from 'components/Row';
import Typography from 'components/Typography';
import { useTheme } from 'styled-components';

export function SunsetBanner() {
	const { spacings, colors } = useTheme();

	return (
		<Banner variant='info'>
			<Row
				justifyContent={'center'}
				style={{
					width: '100%',
					paddingRight: spacings[10],
					paddingLeft: spacings[10],
				}}
			>
				<Row>
					We are sunsetting Coinshift Business by 31st March 2026. Please export
					your data and contact the Coinshift team for further assistance
					at&nbsp;
					<ExternalLink href='mailto:support@coinshift.xyz'>
						<Typography
							style={{
								borderBottom: `${spacings[1]} solid ${colors.white[500]}`,
							}}
							size='sm'
							color='white'
							fontWeight='medium'
						>
							support@coinshift.xyz
						</Typography>
					</ExternalLink>
				</Row>
			</Row>
		</Banner>
	);
}
